module.exports = __webpack_public_path__ + "static/media/DJ.2e4a29ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/DJ.svg
// module id = 238
// module chunks = 0